import api from '../api/axiosInstance';
import { CnisReleasePagination } from '../components/automation-flows/configuration/CnisConfiguration/CnisConfigurationEntities';

export const cnisConfigurationService = {
  get: () => api.get('/api/cnis-configuration'),
  getPaginated: (pagination: CnisReleasePagination) => {
    const searchQuery = pagination.global ? `&global=${pagination.global}` : '';
    const paginationQuery = `limit=${pagination.limit}&offset=${pagination.offset}${searchQuery}`;
    return api.get(`/api/cnis-configuration/paginated?${paginationQuery}`);
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  create: (data: any) => api.put('/api/cnis-configuration', data)
};
